import Slider from 'Partials/slider';
import { Settings } from 'Settings';
import { qq } from 'bobjoll/ts/library/dom';

const sliderWrapper = qq('.slider');
const sliderInstances: Slider[] = [];
const sliderDuration = parseFloat(Settings['slider-timeout']);

sliderWrapper.forEach(slider => sliderInstances.push(new Slider(slider, sliderDuration)));